import { render, staticRenderFns } from "./GroupClasses.vue?vue&type=template&id=626f89f0&"
import script from "./GroupClasses.vue?vue&type=script&lang=js&"
export * from "./GroupClasses.vue?vue&type=script&lang=js&"
import style0 from "./GroupClasses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports